/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import styles from './pricingPackage.module.css'
import CheckMark from './checkMark'
import Link from 'next/link';
import consts from './consts'
import utils from './utils'
import EyeIcon from './eyeIcon';

export default function PricingPackage({header,description, price, period, customText, cta, features, themeColor, packageId,
  showPopularIcon, show, disabled, isUserLoggedIn}) {
  const FREE = 'free';
  const isFreePackage = customText && customText.toLowerCase() === FREE;

  function onCtaClick() {
    utils.trackEvent(consts.TRACKING_CATEGORY.PRICING, 'package_selected','package_id',packageId);
    if(price && !isFreePackage) {
      utils.setSessionStorageItem(consts.SELECTED_PACKAGE.PRICE, price);
    }
    if(isUserLoggedIn) {
      utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PACKAGE_ID, packageId, 7);
      utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PaidPackage, !isFreePackage, 7);
    } else {  //default to free package before the user is signed up
      utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PACKAGE_ID, 1, 7);
      utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PaidPackage, false, 7);
    }

    cta.onClick && cta.onClick();
  }

  function renderShowLiveDemo(ctaLink) {
    return (
      <div className={styles.featureCtaContainer}>
        <EyeIcon iconStyle={{marginRight: '4.5px'}}/>
        <a onClick={() => utils.trackPageView('live-demo')} href={ctaLink} className={styles.featureCtaLink} target="_blank" rel="noopener noreferrer">View Live Demo</a>
      </div>
    );
  }

  function renderHighlightedFeature(featureName) {
    return (
      <div className={styles.highlightedFeatureContainer}>
         <span style={{color: themeColor}} className={styles.highlightedFeatureItemText}>{featureName}</span>
      </div>
    );
  }

  function hexToRgbA(hex){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return [(c>>16)&255, (c>>8)&255, c&255].join(',')
    }
    throw new Error('Bad Hex');
}

  function renderComingSoon() {
    return (
      <div style={{color: themeColor, backgroundColor: `rgba(${hexToRgbA(themeColor)}, 0.2)`}} className={styles.comingSoonContainer}>
        <span>Coming soon</span> 
      </div>
    );
  }

  function renderFeatureItem(feature) {
    let itemText = feature.name;
    let isHighlighted = feature.highlight;
    let isComingSoon = feature.comingSoon;
    return(
      <div key={itemText} className={styles.featureItemContainer}>
        <CheckMark iconColor={themeColor} iconStyle={{marginRight: '10px'}}/>
        {isHighlighted ? renderHighlightedFeature(itemText) : 
        <span className={styles.featureItemText}>{itemText}</span>}
        {feature.ctaLink && renderShowLiveDemo(feature.ctaLink)}
        {isComingSoon && renderComingSoon()}
      </div>
    );
  }

  function renderPopularIcon(iconStyle) {
    return(
      <svg style={iconStyle} xmlns="http://www.w3.org/2000/svg" width="90" height="19" viewBox="0 0 90 19" fill="none">
      <path d="M29.8067 7.77C29.8067 8.33 29.6717 8.855 29.4017 9.345C29.1417 9.835 28.7267 10.23 28.1567 10.53C27.5967 10.83 26.8867 10.98 26.0267 10.98H24.2717V15H22.1717V4.53H26.0267C26.8367 4.53 27.5267 4.67 28.0967 4.95C28.6667 5.23 29.0917 5.615 29.3717 6.105C29.6617 6.595 29.8067 7.15 29.8067 7.77ZM25.9367 9.285C26.5167 9.285 26.9467 9.155 27.2267 8.895C27.5067 8.625 27.6467 8.25 27.6467 7.77C27.6467 6.75 27.0767 6.24 25.9367 6.24H24.2717V9.285H25.9367ZM35.4121 15.135C34.6121 15.135 33.8921 14.96 33.2521 14.61C32.6121 14.25 32.1071 13.745 31.7371 13.095C31.3771 12.445 31.1971 11.695 31.1971 10.845C31.1971 9.995 31.3821 9.245 31.7521 8.595C32.1321 7.945 32.6471 7.445 33.2971 7.095C33.9471 6.735 34.6721 6.555 35.4721 6.555C36.2721 6.555 36.9971 6.735 37.6471 7.095C38.2971 7.445 38.8071 7.945 39.1771 8.595C39.5571 9.245 39.7471 9.995 39.7471 10.845C39.7471 11.695 39.5521 12.445 39.1621 13.095C38.7821 13.745 38.2621 14.25 37.6021 14.61C36.9521 14.96 36.2221 15.135 35.4121 15.135ZM35.4121 13.305C35.7921 13.305 36.1471 13.215 36.4771 13.035C36.8171 12.845 37.0871 12.565 37.2871 12.195C37.4871 11.825 37.5871 11.375 37.5871 10.845C37.5871 10.055 37.3771 9.45 36.9571 9.03C36.5471 8.6 36.0421 8.385 35.4421 8.385C34.8421 8.385 34.3371 8.6 33.9271 9.03C33.5271 9.45 33.3271 10.055 33.3271 10.845C33.3271 11.635 33.5221 12.245 33.9121 12.675C34.3121 13.095 34.8121 13.305 35.4121 13.305ZM43.8121 7.89C44.0821 7.51 44.4521 7.195 44.9221 6.945C45.4021 6.685 45.9471 6.555 46.5571 6.555C47.2671 6.555 47.9071 6.73 48.4771 7.08C49.0571 7.43 49.5121 7.93 49.8421 8.58C50.1821 9.22 50.3521 9.965 50.3521 10.815C50.3521 11.665 50.1821 12.42 49.8421 13.08C49.5121 13.73 49.0571 14.235 48.4771 14.595C47.9071 14.955 47.2671 15.135 46.5571 15.135C45.9471 15.135 45.4071 15.01 44.9371 14.76C44.4771 14.51 44.1021 14.195 43.8121 13.815V18.96H41.7121V6.69H43.8121V7.89ZM48.2071 10.815C48.2071 10.315 48.1021 9.885 47.8921 9.525C47.6921 9.155 47.4221 8.875 47.0821 8.685C46.7521 8.495 46.3921 8.4 46.0021 8.4C45.6221 8.4 45.2621 8.5 44.9221 8.7C44.5921 8.89 44.3221 9.17 44.1121 9.54C43.9121 9.91 43.8121 10.345 43.8121 10.845C43.8121 11.345 43.9121 11.78 44.1121 12.15C44.3221 12.52 44.5921 12.805 44.9221 13.005C45.2621 13.195 45.6221 13.29 46.0021 13.29C46.3921 13.29 46.7521 13.19 47.0821 12.99C47.4221 12.79 47.6921 12.505 47.8921 12.135C48.1021 11.765 48.2071 11.325 48.2071 10.815ZM60.1476 6.69V15H58.0326V13.95C57.7626 14.31 57.4076 14.595 56.9676 14.805C56.5376 15.005 56.0676 15.105 55.5576 15.105C54.9076 15.105 54.3326 14.97 53.8326 14.7C53.3326 14.42 52.9376 14.015 52.6476 13.485C52.3676 12.945 52.2276 12.305 52.2276 11.565V6.69H54.3276V11.265C54.3276 11.925 54.4926 12.435 54.8226 12.795C55.1526 13.145 55.6026 13.32 56.1726 13.32C56.7526 13.32 57.2076 13.145 57.5376 12.795C57.8676 12.435 58.0326 11.925 58.0326 11.265V6.69H60.1476ZM64.7441 3.9V15H62.6441V3.9H64.7441ZM66.7034 10.815C66.7034 9.975 66.8684 9.23 67.1984 8.58C67.5384 7.93 67.9934 7.43 68.5634 7.08C69.1434 6.73 69.7884 6.555 70.4984 6.555C71.1184 6.555 71.6584 6.68 72.1184 6.93C72.5884 7.18 72.9634 7.495 73.2434 7.875V6.69H75.3584V15H73.2434V13.785C72.9734 14.175 72.5984 14.5 72.1184 14.76C71.6484 15.01 71.1034 15.135 70.4834 15.135C69.7834 15.135 69.1434 14.955 68.5634 14.595C67.9934 14.235 67.5384 13.73 67.1984 13.08C66.8684 12.42 66.7034 11.665 66.7034 10.815ZM73.2434 10.845C73.2434 10.335 73.1434 9.9 72.9434 9.54C72.7434 9.17 72.4734 8.89 72.1334 8.7C71.7934 8.5 71.4284 8.4 71.0384 8.4C70.6484 8.4 70.2884 8.495 69.9584 8.685C69.6284 8.875 69.3584 9.155 69.1484 9.525C68.9484 9.885 68.8484 10.315 68.8484 10.815C68.8484 11.315 68.9484 11.755 69.1484 12.135C69.3584 12.505 69.6284 12.79 69.9584 12.99C70.2984 13.19 70.6584 13.29 71.0384 13.29C71.4284 13.29 71.7934 13.195 72.1334 13.005C72.4734 12.805 72.7434 12.525 72.9434 12.165C73.1434 11.795 73.2434 11.355 73.2434 10.845ZM79.9339 7.98C80.2039 7.54 80.5539 7.195 80.9839 6.945C81.4239 6.695 81.9239 6.57 82.4839 6.57V8.775H81.9289C81.2689 8.775 80.7689 8.93 80.4289 9.24C80.0989 9.55 79.9339 10.09 79.9339 10.86V15H77.8339V6.69H79.9339V7.98Z" fill="#2580DE"/>
      <path d="M7.50456 12.9498L3.48713 15L4.25456 10.6576L1 7.58253L5.49129 6.95072L7.5 3L9.50871 6.95072L14 7.58253L10.7454 10.6576L11.5129 15L7.50456 12.9498Z" stroke="#2580DE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }

  function renderCustomText() {
    return (
      <span style={{color: themeColor}} className={styles.priceNumber}>{customText}</span>
    );
  }

  function renderPrice() {
    return (
      <React.Fragment>
       <span style={{color: themeColor}} className={styles.priceNumber}>{`$${price}`}</span>
        <span className={styles.pricePeriod}> {`/${period}`}</span>
      </React.Fragment>
    );
  }

  function renderArrow() {
    return (
      <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.14258 9.32031L17.2854 1.17745" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.14286 9.32031L1 1.17745" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }

  function renderCurrentPackage() {
    return (
      <div className={styles.currentPlanContainer}>
        <span className={styles.currentPlanText}>Your current plan</span>
       {renderArrow()}
      </div>
    )
  }

    return (
      show && <div className={styles.containerWrapper}>
        {disabled && renderCurrentPackage()}
     <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.headerWrapper}>
          <span className={styles.headerText}>{header}</span>
         {showPopularIcon && renderPopularIcon({position: 'relative', 'left': '20px'})}
          </div>
        </div>
    <span className={styles.descriptionText}>{description}</span>
         <div className={styles.priceContainer}>
          {customText ? renderCustomText() : renderPrice()}
        </div> 
        <div className={styles.divider}/>
        <div className={styles.featuresItemsContainer}>
        {features.map((f) => {
        return renderFeatureItem(f)
       })}
        </div>
        <button disabled={disabled} onClick={onCtaClick} style={disabled ? {} : {backgroundColor: themeColor}} className={disabled ? styles.choosePackageLinkDisabled : styles.choosePackageLink}>
          <span className={styles.choosePackageText}>{cta.text}</span>
        </button>
        {false && <Link href={!disabled || !cta.onClick ? cta.url : ''}>
        <a onClick={onCtaClick} style={disabled ? {} : {backgroundColor: themeColor}} className={disabled ? styles.choosePackageLinkDisabled : styles.choosePackageLink}>
          <span className={styles.choosePackageText}>{cta.text}</span>
        </a>
        </Link>}
   </div>
      </div>

    )
  }